import * as React from 'react';

import styled from 'styled-components';
import {
  DangerousElement,
  FootnoteReference,
  useEmissionLabels,
  getActualTestCycles,
  VehicleBasic,
  getConsumptionEmissionRepresentation,
} from '@oneaudi/vtp-shared';
import { Text } from '@audi/audi-ui-react-v2';
import { useI18n } from '@oneaudi/i18n-context';
import { HighlightWrap, CommonHighlight } from './CommonStyledComponents';
import { HighLightItem } from '../interface/highlights.interfaces';
import HighlightInfo from './HighlightInfo';
import { messages } from '../i18n/messages';

interface SimpleItemProps {
  item: HighLightItem;
  vehicle: VehicleBasic;
}

const EmissionValue = styled.span`
  display: block;
`;

const EmissionItem: React.FC<SimpleItemProps> = ({ item, vehicle }) => {
  const { IconLabel, InfoLink, TechdataKey } = item;
  const [primaryEmissionValue, secondaryEmissionValue] = useEmissionLabels(vehicle);
  const emissionCombinedLabel = useI18n(messages.emissionCombinedLabel);
  const actualTestCycles = getActualTestCycles(
    vehicle,
    getConsumptionEmissionRepresentation(),
  ) as Array<string>;

  const carType = vehicle.type === 'N' ? 'new' : 'used';

  return (
    <>
      {!!primaryEmissionValue && actualTestCycles.length > 0 && (
        <>
          <HighlightWrap className="sc-detail-highlight-wrapper" data-tech-key={TechdataKey}>
            <CommonHighlight className="sc-detail-highlight" data-tech-key={TechdataKey}>
              <Text
                as="p"
                variant="copy2"
                spaceStackEnd="xxs"
                className="sc-detail-highlight-label sc-hyphenate"
              >
                <DangerousElement html={IconLabel!} as="span" />
                <FootnoteReference refId={`fn_consumption_stockcar_${carType}`} />
              </Text>
              <Text as="span" variant="copy1" weight="bold" className="sc-hyphenate">
                <EmissionValue>
                  {`${primaryEmissionValue} ${emissionCombinedLabel}`}
                  <FootnoteReference refId={`fn_${actualTestCycles[0].toLowerCase()}_stockcar`} />
                </EmissionValue>
                {!!secondaryEmissionValue && (
                  <>
                    <EmissionValue>
                      {`${secondaryEmissionValue} ${emissionCombinedLabel}`}
                      <FootnoteReference
                        refId={`fn_${actualTestCycles[1].toLowerCase()}_stockcar`}
                      />
                    </EmissionValue>
                  </>
                )}
              </Text>
              {InfoLink ? <HighlightInfo infoLink={InfoLink} /> : ''}
            </CommonHighlight>
          </HighlightWrap>
        </>
      )}
    </>
  );
};

export default EmissionItem;
